<template>
  <div class="space-y-4">
    <div v-if="props.canComment">
      <div v-if="!addingComment">
        <ButtonBase
          color="white"
          shape="rounded"
          size="xs"
          :leadingIcon="PlusIcon"
          @click="addingComment = true"
          >Comment</ButtonBase
        >
      </div>
      <TripCommentForm
        v-else
        @close="addingComment = false"
        :trip="props.trip"
      />
    </div>

    <FeedMultiItem v-if="activity.length" class="mt-3" :activity="activity">
      <template #item="{ activityItem }">
        <!-- Override the FeedItemComment so we can inject the form component -->
        <FeedItemComment
          v-if="activityItem.component == FeedItemComment"
          :activityItem="activityItem"
          @delete="showCommentConfirmDeleteModal(activityItem)"
        >
          <template #form="{ activityItem, cancelEdit }">
            <TripCommentForm :comment="activityItem" @close="cancelEdit" />
          </template>
        </FeedItemComment>
      </template>
    </FeedMultiItem>
  </div>

  <CommentConfirmDeleteModal
    v-bind="commentConfirmDeleteModalProps"
    @close="closeCommentConfirmDeleteModal"
    routeName="trips.comments.destroy"
  />
</template>

<script setup>
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import CommentConfirmDeleteModal from '@/Common/Lists/Feeds/FeedComments/CommentConfirmDeleteModal.vue'
import { useCommentConfirmDeleteModal } from '@/Common/Lists/Feeds/FeedComments/useCommentConfirmDeleteModal'
import FeedItemComment from '@/Common/Lists/Feeds/FeedItems/FeedItemComment.vue'
import FeedMultiItem from '@/Common/Lists/Feeds/FeedMultiItem.vue'
import { formatDateTimeShort } from '@/Util/DateFilters'
import { PlusIcon } from '@heroicons/vue/solid'
import { computed, ref } from 'vue'
import TripCommentForm from './TripCommentForm.vue'

const props = defineProps({
  trip: Object,
  canComment: Boolean,
})

const activity = computed(() => {
  return props.trip.comments.map((comment) => {
    return {
      component: FeedItemComment,
      id: comment.id,
      user: comment.user,
      body: comment.body,
      date: formatDateTimeShort(comment.created_at),
      can: comment.can,
    }
  })
})

// Comments
const addingComment = ref(false)

const {
  commentConfirmDeleteModalProps,
  showCommentConfirmDeleteModal,
  closeCommentConfirmDeleteModal,
} = useCommentConfirmDeleteModal()
</script>
